import { Icon } from '@iconify/react';
import { useSnackbar } from 'notistack5';
import { useRef, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import personFill from '@iconify/icons-eva/person-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { alpha } from '@material-ui/core/styles';
import { Button, Box, Divider, MenuItem, Typography } from '@material-ui/core';
// routes
import { PATH_DASHBOARD, PATH_PAGE } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
// components
import { MIconButton } from '../../components/@material-extend';
import MyAvatar from '../../components/MyAvatar';
import MenuPopover from '../../components/MenuPopover';
import FormSettings from '../../pages/settings/FormSettings';
import { useSelector } from '../../redux/store';
// ----------------------------------------------------------------------



// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const isMountedRef = useIsMountedRef();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [isShowFormSettings, setIsShowFormSettings] = useState(false);
  const { io } = useSelector((state) => state.io);
  const MENU_OPTIONS = [
    // {
    //   label: 'Trang chủ',
    //   icon: homeFill,
    //   linkTo: '/'
    // },
    // {
    //   label: 'Profile',
    //   icon: personFill,
    //   linkTo: PATH_DASHBOARD.user.profile
    // },
    {
      label: 'Thông tin cá nhân',
      icon: "lucide:settings-2",
      // linkTo: PATH_PAGE.settings
    }
  ];
  const handleOpenFormSettings = () => {
    setIsShowFormSettings(true);
    setOpen(false);
  }
  const handleCloseFormSetting = () => {
    setIsShowFormSettings(false);
  }
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      if (io) {
        io.disconnect();
      }

      await logout();
      // navigate('/');
      window.location="/"
      if (isMountedRef.current) {
        handleClose();
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Đăng xuất lỗi', { variant: 'error' });
    }
  };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <MyAvatar />
      </MIconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 220, p: 0, overflow: "hidden" }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {user ? user.full_name : "undefined"}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user ? user.email : "undefined "}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            // to={option.linkTo}
            component={RouterLink}
            onClick={handleOpenFormSettings}
            sx={{ py: 1, px: 2.5, color: '#303187', fontSize: '14px', fontWeight: '700' }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              color="#303187"
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button fullWidth sx={{ backgroundColor: "#303187", color: "#fff" }} variant="contained" onClick={handleLogout}>
            Đăng xuất
          </Button>
        </Box>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ height: "15px", width: '75%', float: "right", background: "#41c7f5", clipPath: 'polygon(0 0, 100% 0, 100% 100%, 5% 100%)' }}> </Box>
          <Box sx={{ height: "15px", width: '40%', background: "red", clipPath: 'polygon(0 0, 93% 0, 100% 100%, 0 100%)' }}> </Box>
        </Box>
      </MenuPopover>
      {isShowFormSettings && <FormSettings
        isOpen={isShowFormSettings}
        onClose={handleCloseFormSetting}
      />}

    </>
  );
}
